import React, { useMemo, useRef, useState } from "react";

import AngleUp from "assets/icons/studentFolder/angleUpStudentFolderFilter.svg";
import AngleDown from "assets/icons/studentFolder/angleDownStudentFolderFilter.svg";

import "./styles.scss";
import RadioButton from "common/components/RadioButton";
import { useOutsideAlerter } from "features/game/components/Pagination/CustomSelect";

interface Props {
  onChangeLesson?: (val: number) => void;
}

const FilterStudentFolder = ({ onChangeLesson }: Props) => {
  const [activeFilter, setActiveFilter] = useState(1);
  const [isActiveFilter, setIsActiveFilter] = useState(false);
  const wrapperRef = useRef(null);
  useOutsideAlerter(wrapperRef, () => {
    setIsActiveFilter(false);
  });

  const titleFilter = useMemo(() => {
    switch (activeFilter) {
      case 1:
        return "הכל";
      case 2:
        return "פתרתי";
      case 3:
        return "פתרתי מזמן";
      case 4:
        return "ניסיתי";
      case 5:
        return "לא התחלתי";
      default:
        return "הכל";
    }
  }, [activeFilter]);

  return (
    <div style={{ position: "relative" }} ref={wrapperRef}>
      <div className="filter-student-folder-wrapper" onClick={() => setIsActiveFilter(true)}>
        <span
          className="title-filter-student-folder"
          style={{ whiteSpace: "nowrap", width: 60, overflow: "hidden" }}>
          {titleFilter}
        </span>
        <img src={AngleDown} style={{ marginLeft: 2.5 }} />
      </div>
      {isActiveFilter && (
        <div className="filter-student-folder-wrapper-open">
          <div
            className="filter-student-folder-container-open"
            onClick={() => setIsActiveFilter(false)}>
            <span className="title-filter-student-folder">{titleFilter}</span>
            <img src={AngleDown} style={{ marginLeft: 2.5 }} />
          </div>
          <div className="filter-student-folder-content-open">
            <RadioButton
              label="הכל"
              active={activeFilter === 1}
              onClick={() => {
                setActiveFilter(1);
                onChangeLesson && onChangeLesson(0);
              }}
            />
            <RadioButton
              label="פתרתי"
              active={activeFilter === 2}
              onClick={() => {
                setActiveFilter(2);
                onChangeLesson && onChangeLesson(1);
              }}
            />
            <RadioButton
              label="פתרתי מזמן"
              active={activeFilter === 3}
              onClick={() => {
                setActiveFilter(3);
                onChangeLesson && onChangeLesson(2);
              }}
            />
            <RadioButton
              label="ניסיתי"
              active={activeFilter === 4}
              onClick={() => {
                setActiveFilter(4);
                onChangeLesson && onChangeLesson(3);
              }}
            />
            <RadioButton
              label="לא התחלתי"
              active={activeFilter === 5}
              onClick={() => {
                setActiveFilter(5);
                onChangeLesson && onChangeLesson(4);
              }}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default FilterStudentFolder;
